<template>
    <div class="af-job-apply-container afu-flex afu-flex-wrap">
        <div :class="{'af-job-apply-jobview-content af-container-light-bg afu-bg-white afu-w-full md:afu-w-1/4 afu-border afu-border-l-0 afu-border-t-0 afu-border-b md:afu-border-b-0 afu-border-r-0  md:afu-border-r afu-border-neutral afu-border-solid afu-box-border md:afu-max-h-100vh afu-sticky afu-top-0 afu-z-100 md:afu-z-auto': true, 'afu-desccription-open': show}">
            <C1Spinner
                v-if="loading"
                variant="primary"
                small
            />
            <template v-else>
                <MqLayout mq="sm">
                    <JobViewContentMobile
                        isApplyView
                        :showCompanyLogo="false"
                        :widget="false"
                        :description="false"
                        @toggleDescription="toggleDescriptionClass"
                    />
                </MqLayout>
                <MqLayout mq="tsm+">
                    <JobViewContent
                        scrollbar
                        isApplyView
                    />
                </MqLayout>
            </template>
        </div>
        <C1Spinner
            v-if="loading"
            variant="primary"
            small
        />
        <div
            class="af-job-apply-flow md:afu-w-3/4 afu-w-full "
            :class="{'afu-px-5 afu-py-7 md:afu-px-10 md:afu-py-10 afu-box-border md:afu-bg-neutral-light':!applyInIframe, 'afu-h-full':applyInIframe }"
        >
            <div
                v-if="!loading"
                :class="{'afu-max-w-1000 afu-mx-auto':!applyInIframe}"
            >
                <ApplyComplete v-if="$_isApplyComplete" />
                <template v-else-if="this.$_job">
                    <div v-if="applyInIframe || isMatchedDomain">
                        <iframe
                            class="afu-w-full afu-h-full afu-border-0 afu-h-100vh"
                            :src="this.getIframeLink"
                        >
                            <!--iframe link-->
                        </iframe>
                    </div>
                    <div v-else>
                        <ApplyHeader />
                        <ApplyWithAccounts />
                        <!-- <ApplyFormGuest v-if="$_isApplyAsGuestUser && !$_me.id" />  -->
                        <ApplyFormNewUser v-if="$_isApplyAsNewUser" />
                        <ApplyForm v-else-if="($_isApplyAsExistingUser || $_isApplyAsRecognisedUser) && $_me.id" />
                        <template v-else>
                            <div class="afu-font-semibold afu-text-xs afu-leading-xs afu-mb-8 afu-text-black">
                                {{ $t('apply.apply_with_email_title') }}
                            </div>
                            <Auth
                                variant="success"
                                @user="onUserChange"
                                @afterLogin="setApplyAsExistingUser"
                                @handleGuestApply="setApplyAsGuestUser"
                                @handleApplyAsNewUser="setApplyAsNewUser"
                                :job-uuid="$_job.uuid"
                            >
                                <template slot="registerFields" />
                            </Auth>
                        </template>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

    import C1Spinner from '@/components/C1Components/C1Spinner';
    import JobViewContent from '@/apps/jobview/001/components/JobViewContent';
    import JobViewContentMobile from '@/apps/jobview/001/components/JobViewContentMobile';
    import Auth from '@/components/Auth/Auth';
    import ApplyHeader from './JobView/Apply/ApplyHeader';
    import ApplyForm from './JobView/Apply/ApplyForm';
    // import ApplyFormGuest from './JobView/Apply/ApplyFormGuest';
    import ApplyFormNewUser from './JobView/Apply/ApplyFormNewUser';
    import ApplyComplete from './JobView/Apply/ApplyComplete';
    import ApplyWithAccounts from './ApplyWith/ApplyWithAccounts';
    import Cookie from '@/services/cookie';
    import ApplyJobMixin from '@/apps/jobview/001/components/Actions/ApplyJobMixin.vue';

    export default {
        name: 'Apply',

        components: {
            JobViewContent,
            JobViewContentMobile,
            C1Spinner,
            Auth,
            ApplyHeader,
            ApplyWithAccounts,
            ApplyForm,
            // ApplyFormGuest,
            ApplyFormNewUser,
            ApplyComplete,
        },

        data() {
            return {
                loading: false,
                jobUuidApply: '',
                guest: {
                    user:  {
                        email: '',
                        first_name: '',
                        last_name: '',
                        contact_number: '',
                    },
                    resume_id: '',
                },
                show: false,
            };
        },

        mixins:[ApplyJobMixin],

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_jobApplication: state => state.jobApplication,
                $_job: state => state.job.job,
            }),

            ...mapGetters('jobApplication', {
                $_applyEmail: 'applyEmail',
                $_isApplyAsExistingUser: 'isApplyAsExistingUser',
                $_isApplyAsNewUser: 'isApplyAsNewUser',
                $_isApplyAsGuestUser: 'isApplyAsGuestUser',
                $_isApplyAsRecognisedUser: 'isApplyAsRecognisedUser',
                $_isApplyComplete: 'isApplyComplete',
            }),

            matchJobsFilter() {
                return {
                    fields: [
                        'uuid',
                        'activates_at',
                        'applyflow_custom_1_details',
                        'applyflow_custom_2_details',
                        'applyflow_custom_3_details',
                        'applyflow_custom_4_details',
                        'job_description',
                        'job_title',
                        'location_label',
                        'pay_is_estimated',
                        'pay_hidden',
                        'pay_min',
                        'pay_max',
                        'pay_type',
                    ],
                    work_locations: [
                        this.$_job.location_id,
                    ],
                    skills: this.$_job.skills_details ? this.$_job.skills_details.map((o) => {
                        return o.id;
                    }) : [],
                    occupations: [
                        {
                            occupation_id: this.$_job.occupation_id,
                            weight: '1.0000',
                        },
                    ],
                    categories: [
                        {
                            category_id: this.$_job.category_id,
                        },
                    ],
                    match_type: 'top-matches',
                    exclude_uuids: [this.$_job.uuid],
                    per_page: 3,
                };
            },

            applyInIframe() {
                return this.isApplyInIframe() && this.$_job?.apply_type_id === '2' && this.$_job?.apply_url;
            },

            isMatchedDomain() {
                return this.hasMatchedDomain();
            },

            getIframeLink() {
                const applyUrl = new URL(this.$_job.apply_url);
                const utmSrc = this.getSource();
                // if (applyUrl.searchParams.has('source')) {
                //     applyUrl.searchParams.set('source', utmSrc);
                //     return applyUrl.toString();
                // }
                return applyUrl.toString() + this.getQuerySymbol() + 'source=' + utmSrc;
            },
        },

        async created() {
            this.jobUuidApply = this.$route.params.uuid; // updated variable name; variable name conflicted prop causing the application to throw prop mutation error
            this.loading = true;
            await this.$_getJob({ jobUuid: this.jobUuidApply, createToken: true }).then(res => {
                if (res.status === 200) {
                    this.loading = false;
                    if (this.$_me.id) {
                        const userCanApply = this.userCanApply(res.data.data.user_application_count);
                        if (!userCanApply) {
                            window.location.href = '/user-dashboard/';
                        }
                    }
                } else {
                    window.location.href = '/jobs/';
                }
            }).catch(() => {
                window.location.href = '/jobs/';
            });
        },

        mounted() {
            if (this.$_me.id) {
                const user = {
                    email: this.$_me.email,
                    first_name: this.$_me.first_name,
                    last_name: this.$_me.last_name,
                    contact_number: this.$_me.contact_number,
                };
                this.setUser(user);
                this.setApplyAsExistingUser();
            } else if (this.$route.query?.af_scode && this.$route.query?.af_cbtype == 'seek' && this.$route.query?.af_cbaction == 'apply') {
                this.$_seekLogin({
                    code: this.$route.query.af_scode,
                    advertiserId: window?.afConfig?.seek_advertiser_id,
                    jobUrl: encodeURIComponent(window.location.href.split('?')[0]),
                }).then(async(res) => {
                    this.$_storeUser(res.data);
                    await Cookie.setToken(res.access_token);
                    const user = {
                        email: res.data.email,
                        first_name: res.data.first_name,
                        last_name: res.data.last_name,
                        contact_number: res.data.contact_number,
                    };
                    this.setUser(user);
                    this.setApplyAsExistingUser();
                });
            } else if (this.$route.query?.email) {
                this.guest =  {
                    user:  {
                        email: this.$route.query.email,
                        first_name: this.$route.query.first_name,
                        last_name: this.$route.query.last_name,
                        contact_number: this.$route.query.contact_number,
                    },
                    resume_id: this.$route.query.id,
                };
                this.setUser(this.guest.user);
                this.setApplyAsExistingUser();
                if (this.guest.resume_id) {
                    this.$_getGuestResume(this.guest.resume_id).then((response) => {
                        this.$_STORE_RESUME(response.data);
                    });
                }
            }
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_STORE_APPLY_USER: 'STORE_USER',
                $_STORE_APPLY_AS_EXISTING_USER: 'STORE_APPLY_AS_EXISTING_USER',
                $_STORE_APPLY_AS_GUEST_USER: 'STORE_APPLY_AS_GUEST_USER',
                $_STORE_APPLY_AS_NEW_USER: 'STORE_APPLY_AS_NEW_USER',
                $_OPEN_APPLY_FORM: 'OPEN_APPLY_FORM',
                $_STORE_APPLY_STEP: 'STORE_APPLY_STEP',
            }),

            ...mapMutations('me', {
                $_STORE_GUEST_RESUME: 'STORE_GUEST_RESUME',
                $_STORE_RESUME: 'STORE_RESUME',
            }),

            ...mapActions('me', {
                $_getMe: 'getMe',
                $_checkUserEmail: 'checkEmail',
                $_getGuestResume: 'getGuestResume',
                $_storeUser: 'storeAllUserData',
                $_storeAllUserData: 'storeAllUserData',
            }),

            ...mapActions('auth', {
                $_seekLogin: 'seekLogin',
            }),

            ...mapActions('job', {
                $_getJob: 'getJob',
            }),

            onUserChange(user) {
                this.$_STORE_APPLY_USER(user);
            },

            setUser(user) {
                this.$_STORE_APPLY_USER(user);
                if (!user.id) {
                    this.$_STORE_APPLY_AS_NEW_USER();
                }
            },

            setApplyAsExistingUser() {
                this.$_getMe();
                this.$_STORE_APPLY_AS_EXISTING_USER();
                this.$_OPEN_APPLY_FORM();
                this.$_STORE_APPLY_STEP(2);
            },

            setApplyAsNewUser() {
                this.$_STORE_APPLY_AS_NEW_USER();
                this.$_STORE_APPLY_STEP(2);
            },

            setApplyAsGuestUser() {
                this.$_STORE_APPLY_AS_GUEST_USER();
                this.$_STORE_APPLY_STEP(2);
            },

            toggleDescriptionClass(show) {
                this.show = show;
            },

            storeUserAfterLogin(data) {
                const user = data.data;
                this.$_storeAllUserData(user);
                this.$_STORE_APPLY_USER({
                    email: user.email,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    contact_number: user.contact_number,
                });
                Cookie.setToken(data.access_token);
            },

            userCanApply(applicationCount) {
                const allowJobReapply = window?.afConfig?.allow_job_reapply;
                if (!allowJobReapply) {
                    return true;
                }
                const canReapply = allowJobReapply.toLowerCase() === 'yes';
                if (!canReapply) {
                    return false;
                }
                const jobReapplyLimit = window.afConfig?.job_reapply_limit;
                if (!jobReapplyLimit || jobReapplyLimit === '' || applicationCount < jobReapplyLimit) {
                    return true;
                }
                return false;
            },

        },
    };
</script>
<style scoped>
    .afu-desccription-open + .af-job-apply-flow {
        overflow: hidden;
        max-height: 1px;
        padding: 0;
    }
</style>
